import { image_host } from "config/api_host";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function NavigationCard({
  image,
  name,
  link,
  is_available = true,
}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <Link
      to={is_available ? link : "#"}
      onClick={(e) => {
        if (!is_available) {
          e.preventDefault();
        }
      }}
      className={`group relative mx-auto grid h-fit w-full max-w-80 ${
        is_available ? "cursor-pointer" : "cursor-not-allowed"
      }`}
    >
      {!is_available ? (
        <div className="absolute right-3 top-3 z-20 rounded-2xl border border-white/20 bg-[linear-gradient(135deg,#FFB25B,#FF8B1F)] px-4 py-2 text-white shadow-[0_12px_30px_rgba(229,106,0,0.28)]">
          <h1 className="text-center text-sm font-bold">غير متوفر</h1>
        </div>
      ) : null}

      <div className="relative h-fit overflow-hidden rounded-[1.5rem] border border-[rgba(255,178,91,0.22)] bg-[linear-gradient(180deg,rgba(255,255,255,0.18),rgba(255,244,232,0.14))] p-3 pb-1.5 shadow-[0_24px_48px_rgba(91,36,0,0.08)] transition-all duration-300 group-hover:-translate-y-1 group-hover:border-[rgba(255,139,31,0.34)] group-hover:shadow-[0_22px_44px_rgba(229,106,0,0.16)] dark:bg-[linear-gradient(180deg,rgba(91,36,0,0.38),rgba(42,18,0,0.3))] dark:shadow-[0_26px_54px_rgba(0,0,0,0.28)]">
        <div className="pointer-events-none absolute inset-x-6 top-0 h-16 rounded-b-full bg-[radial-gradient(circle_at_top,rgba(255,178,91,0.34),transparent_72%)] dark:bg-[radial-gradient(circle_at_top,rgba(255,178,91,0.24),transparent_72%)]" />

        {!loaded ? (
          <div className="mx-auto mb-3 h-[100px] w-full max-w-[268px] animate-pulse rounded-2xl bg-[linear-gradient(135deg,rgba(255,178,91,0.22),rgba(255,139,31,0.12))] md:h-[120px] dark:bg-[linear-gradient(135deg,rgba(255,178,91,0.18),rgba(229,106,0,0.12))]" />
        ) : null}

        <img
          src={`${image_host}${image}`}
          alt={name || ""}
          className={`relative mx-auto h-full max-h-[141px] w-full max-w-[268px] rounded-xl border border-[rgba(255,178,91,0.16)] transition-transform duration-300 ${
            !is_available ? "grayscale" : "group-hover:scale-[1.03]"
          } ${loaded ? "block" : "hidden"}`}
          onLoad={() => setLoaded(true)}
        />

        <h5
          className="my-2 text-center text-sm font-bold md:text-base"
          style={{
            color: is_available
              ? "var(--layout-accent-strong)"
              : "var(--layout-text)",
          }}
        >
          {name}
        </h5>
      </div>
    </Link>
  );
}
// s
